import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InvoiceVisibility from './InvoiceVisibility';
import { getChannelPartnerListing, getContractsByChannelPartner, invoiceVisibilityByChannelPartner } from 'services/redux/sales/channelPartner/action';

const mapStateToProps = (state) => ({
  channelPartnerListing: state.channelPartnerReducer.channelPartnerListing,
  contractsListByChannelPartner: state.channelPartnerReducer.contractsListByChannelPartner,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getChannelPartnerListing,
      getContractsByChannelPartner,
      invoiceVisibilityByChannelPartner
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceVisibility);